let tags = [];
let errors = [];
import _ from 'lodash';
import * as $ from 'jquery';
export function validator(values) {

    tags = [];
    errors = [];
    values.forEach((val, index) => {
        let onlyNum = /^\d+$/;
        let isnum = onlyNum.test(val);
        if(val.includes('-') && !val.includes('_') && !val.includes('BATCH'))
            handleTagRange(val, index);
        else if (val.includes('-') && val.includes('_') && !val.includes('BATCH'))
            handAlphaNumTagRange(val, index)
        else if (val.includes('_'))
            handleAlphaNumTag(val, index);
        else if (isnum)
            checkNumbersOnly(val, index);
        else {
            tags[index] = val;
            errors.push('Your input is in wrong format');
        }

    });
    return [
        tags.filter(onlyUnique), errors.filter(onlyUnique)
    ]
}
        export function verifyIntersection(values) {
            let start= null;
            let end = null;


        }
        export function getDiff(select, postTags){

                let final = [];

                for (var i = 0; i< select.length; i++){
                    if (postTags.includes(select[i]))
                        continue;
                    else
                        final.push(select[i]);
                }




            return final;
        }
export function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}


 function handleTagRange(val, index){
     let tag = val;

     let splitter = tag.split('-');
     let start = splitter[0];
     let end = splitter[1];
     console.log(start, end)
     tags[index] = 'TAG_'+start + '-' + 'TAG_'+end;

}
function handAlphaNumTagRange(val, index) {
    let tag = val;

    let splitter = tag.split('-');
    let start = splitter[0];
    let end = splitter[1];



    let start_split = start.split('_');
    let start_text = start_split[0];
    let start_num = start_split[1];

    let end_split = end.split('_');
    let end_num = end_split[1];

    tags[index] = 'TAG_'+start_num + '-' + 'TAG_'+end_num;

}
export function handleAlphaNumTag(val, index){
    let tag = val;
    let position = tag.indexOf('_');
    tag = tag.split('_');
    let text = tag[0];
    text = _.toUpper(text);
    let num = tag[1];
    performValidations(num)
    if (['BAG', 'ROLL', 'BATCH'].includes(text))
        tags[index] = 'BATCH'+val.substr(position, val.length);
    else
    tags[index] = 'TAG_'+num;
}
export function checkNumbersOnly(val, index){
    performValidations(val);
    tags[index] = 'TAG_'+val;
}
function performValidations(val) {
    if (verifyMaxLength(val)){
        errors.push('Max Length is 9')
    }
    if (verifySpecialCharacter(val))
        errors.push('Special character not allowed')
}
function verifyMaxLength(num){
    return num.length > 9;
}
function verifySpecialCharacter(text){
    return /[!@#$%^&*(),.?":{}|<>]/.test(text);
}
